import { computed } from "nanostores";

import { getExtensionInfoBlock } from "../api";
import { createApiStore } from "./api-store";
import { $router } from "./router";

const parsePositiveRouteId = (
  raw: null | string | undefined,
): null | number => {
  if (raw == null || raw === "") {
    return null;
  }

  const id = Number.parseInt(raw, 10);
  if (!Number.isInteger(id) || id <= 0 || String(id) !== raw) {
    return null;
  }

  return id;
};

export const $extensionInfoBlockContent = createApiStore(
  getExtensionInfoBlock,
  {
    mapToOptions: ([blockId]) => {
      const id = parsePositiveRouteId(blockId);
      if (id === null) {
        throw new Error("Invalid InfoBlock id");
      }

      return { path: { id } };
    },
    params: [
      computed($router, (router) => {
        if (router?.route !== "extensionInfoBlocksEdit") return null;
        const id = parsePositiveRouteId(router.params.blockId);
        return id === null ? null : String(id);
      }),
    ],
    storeKey: "extensionInfoBlockContent",
  },
);
